import React from 'react'
import { Message } from 'sb-react-intl'

import { Button, buttonMessages } from 'components/_new/controls'

import s from './Mobile.scss'


const Mobile = (props) => {
  const {
    children, confirmTitle, cancelTitle, withTextCancel, confirmTestId, cancelTestId,
    onConfirm, onCancel,
  } = props

  return (
    <div>
      {children}
      <Button
        className={s.confirmButton}
        title={confirmTitle || buttonMessages.confirm}
        color="brand"
        size="md"
        fullWidth
        dataTestId={confirmTestId}
        onClick={onConfirm}
      />
      {
        withTextCancel ? (
          <Message
            className={s.textCancel}
            text={cancelTitle || buttonMessages.back}
            html
            dataTestId={cancelTestId}
            onClick={onCancel}
          />
        ) : (
          <div className={s.footer}>
            <Button
              title={cancelTitle || buttonMessages.back}
              color="white"
              size="md"
              fullWidth
              dataTestId={cancelTestId}
              onClick={onCancel}
            />
          </div>
        )
      }
    </div>
  )
}


export default Mobile
